import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { AnyAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as Quotes from '../slices/quotesSlice';
import QuoteListItem from './quotelistitem';
import * as UI from '../slices/uiSlice';
import * as Forms from '../slices/formsSlice';
import SearchQuotes from './searchquotes';
import icon_quote from '../assets/Quote_White.svg';
import '../App.css';

const QuoteList = () => {
	const quotes = useAppSelector(state => state.quotes);
	const user = useAppSelector(state => state.user);
	const [quotesData, setQuotesData] = useState<Quotes.quoteListState[]>([]);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(Quotes.setSkip('0'));
		dispatch(Quotes.setRowsPerPage('50'));
		const visibleQuotes = quotes.quotes.filter((item: Quotes.quoteListState) => (item.visible));
		setQuotesData(visibleQuotes);
	}, [quotes.quotes]);

	const newQuote = () => {
		const removequoteform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("QF")) as unknown as AnyAction)));
		const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
		const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
		removequoteform().then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/quote'));
	}

	const actionOnClick = (item: Quotes.sortType) => {
		dispatch(Quotes.setsortType(item));
	}

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const handlePageChange = (isIncrement: boolean) => {
		if (isIncrement && quotes.skip + 1 >= Math.ceil(quotesData.length / quotes.rowsPerPage)) {
			return;
		} else if (!isIncrement && quotes.skip - 1 < 0) {
			return;
		} else {
			dispatch(Quotes.setSkip((isIncrement ? quotes.skip + 1 : quotes.skip - 1).toString()));
		}
	}

	const handleRowsPerPage = (e: React.ChangeEvent<HTMLSelectElement>) => {
		dispatch(Quotes.setSkip('0'));
		dispatch(Quotes.setRowsPerPage(e.target.value));
	}

	return (
		<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
			<div className='OrangeBand'>
				<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_quote} alt='Quote-Icon' />
						<div style={{ marginLeft: 24 }}>
							<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Your Quote List</div>
						</div>
					</div>
					<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 20, border: '4px solid white' }} onClick={() => newQuote()}>
						<div style={{ display: 'flex' }}>
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24 }}>Get a Quote</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
						</div>
					</div>
				</div>
			</div>
			<div style={{ display: 'flex', alignItems: 'center', width: '100%', backgroundColor: 'white', color: 'black', fontSize: 12 }}>
				<SearchQuotes />
			</div>
			<div style={{ backgroundColor: 'white' }}>
				<div className="row100">
					<div className="row100">
						<div className="flexGrow1 TabHeaderLeft" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Reference' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Reference</div>
								{quotes.sortType.type === 'Reference' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Reference' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Type' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Type</div>
								{quotes.sortType.type === 'Type' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Type' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						<div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Name' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Name</div>
								{quotes.sortType.type === 'Name' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Name' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						{user.id === "128568" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'NHGStaffName' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>NHG Staff Name</div>
								{quotes.sortType.type === 'NHGStaffName' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'NHGStaffName' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Consultant' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Consultant</div>
								{quotes.sortType.type === 'Consultant' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Consultant' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Site' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Site</div>
								{quotes.sortType.type === 'Site' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Site' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Developer' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Developer</div>
								{quotes.sortType.type === 'Developer' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Developer' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'PLSSalesStaff' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>PLS Sales Staff</div>
								{quotes.sortType.type === 'PLSSalesStaff' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'PLSSalesStaff' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Created' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Created</div>
								{quotes.sortType.type === 'Created' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Created' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Generated' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Generated</div>
								{quotes.sortType.type === 'Generated' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Generated' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Accepted' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Accepted</div>
								{quotes.sortType.type === 'Accepted' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Accepted' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Instructed' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Instructed</div>
								{quotes.sortType.type === 'Instructed' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'Instructed' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'SignedClientDocuments' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Signed Client Documents</div>
								{quotes.sortType.type === 'SignedClientDocuments' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'SignedClientDocuments' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'MoniesOnAccount' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Monies on Account</div>
								{quotes.sortType.type === 'MoniesOnAccount' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'MoniesOnAccount' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
						{user.id === "566278" && <div className="flexGrow2 TabHeaderRight" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'VoucherDue' })}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: 8, width: '100%', alignItems: 'center' }}>
								<div>Voucher Due</div>
								{quotes.sortType.type === 'VoucherDue' && !quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
								}
								{quotes.sortType.type === 'VoucherDue' && quotes.sortType.reverse &&
									<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
								}
							</div>
						</div>}
					</div>
				</div>
			</div>
			<div style={{ position: 'absolute', top: 236, left: 0, right: 0, bottom: 1, overflowY: 'scroll', color: 'black', height: 'calc(100vh - 454px)' }} onScroll={handleScroll}>
				{quotesData?.map((item: Quotes.quoteListState, index: number) => (
					(index >= (quotes.skip * quotes.rowsPerPage) && index < ((quotes.skip + 1) * quotes.rowsPerPage)) && <QuoteListItem key={item.quoteid} {...item} />
				))}
			</div>
			<div style={{ position: "absolute", bottom: 0, right: 30, width: "100%", backgroundColor: "white", display: "flex", justifyContent: "flex-end", height: '51px' }}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: '20px', padding: "0 16px", color: "#000", width: "320px" }}>
					<div style={{ display: "flex", whiteSpace: "nowrap", alignItems: "Center", gap: "10px", position: 'relative' }}>Rows Per Page:
						<select value={quotes.rowsPerPage} onChange={handleRowsPerPage} className='WhiteOnOrange' style={{ height: '30px', width: '100px', textAlign: 'center' }}>
							<option value={20}>20</option>
							<option value={50}>50</option>
							<option value={100}>100</option>
							<option value={200}>200</option>
						</select>
						<div className="rowsPerPageArrow arrow right"></div>
					</div>

					<div className='paginationRightContainer'>
						<div style={{ whiteSpace: 'nowrap' }}>{quotes.skip + 1} of {Math.ceil(quotesData.length / quotes.rowsPerPage)}</div>
						<div style={{ display: "flex", gap: "16px" }}>
							<span style={{ opacity: quotes.skip - 1 < 0 ? "0.3" : 1 }} className="arrow left" onClick={() => handlePageChange(false)}></span>
							<span style={{ opacity: quotes.skip + 1 >= Math.ceil(quotesData.length / quotes.rowsPerPage) ? "0.3" : 1 }} className='arrow right' onClick={() => handlePageChange(true)}></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default QuoteList;